import React from "react";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import usePayment from "./usePayment";
import { Outlet } from "react-router-dom";

const Payment = () => {
  const { drawerMenu } = usePayment();
  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default Payment;
